import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

import colors from "@styles/colors";

const SpinnerForContentLoading = ({
  useConfigSpinner,
  spinnerStatus = "",
  divWithWidthToMatch,
  topOffset,
  useContainerHeight = false,
  spinnerMainStyle = {},
}) => {
  // set the width to the parent container created outside of Reac‰
  const storeSpinnerStatus = useSelector((state) => state.config.spinnerStatus);
  let spinnerIsOpen =
    (useConfigSpinner && storeSpinnerStatus === "loading") ||
    (!useConfigSpinner && spinnerStatus === "loading");
  let elementContainer =
    document.getElementById(divWithWidthToMatch) ||
    document.getElementById("root");

  return spinnerIsOpen ? (
    <div
      className="spinner-for-content-loading"
      style={{
        position: "fixed",
        ...(elementContainer
          ? { width: elementContainer.offsetWidth }
          : { margin: "auto" }),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...(useContainerHeight && elementContainer
          ? { height: elementContainer.offsetHeight }
          : { top: "50vh" || topOffset }),
        zIndex: "1301",
        ...spinnerMainStyle,
      }}
    >
      <div
        className="spinner-background"
        style={{
          display: "flex",
          borderRadius: "20px",
          width: "80px",
          backgroundColor: "#9c9c9cd6",
          height: "80px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ClipLoader color={colors.gpshopperBlue} loading={spinnerIsOpen} />
      </div>
    </div>
  ) : null;
};

export default SpinnerForContentLoading;
